import backgroundImg from "../../Assets/images/clientpage/bg.png";
import CustomerPortal from "../../Components/CustomerPortal/CustomerPortal";
function Bank() {
  return (
    <div
      className="container-fluid"
      style={{
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        width: "100vw", // Adjust this to your needs
      }}
    >
      <CustomerPortal />
    </div>
  );
}

export default Bank;
